// Yes/No status tag for the staff-settings list. Uses the design-system
// defaults (guidelines 05 §1/§14): Yes → success-green on green-bg, No → muted
// grey on grey-bg. (To be reconciled against the customer-attributes report
// colors later if they differ — see resolved-decisions.)

export function YesNoTag({ value }: { value: boolean }) {
  return value ? (
    <span className="inline-block rounded px-2 py-0.5 text-small font-medium text-success-green bg-green-bg">
      כן
    </span>
  ) : (
    <span className="inline-block rounded px-2 py-0.5 text-small font-medium text-secondary-text bg-grey-bg">
      לא
    </span>
  );
}
